const isAndroid = () => {
    const u = navigator.userAgent
    return u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; 
}

export {
    isAndroid
}